import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  nl: {
    common: {
      back: 'Terug',
    },
    metadata: {
      site_name: 'P.E.N.T.A.G.O.N.',
      home_title: 'P.E.N.T.A.G.O.N.',
      home_description: 'Voor iedereen, behalve echte illuminaten, een ondoorgrondelijk geheim.',
      members_title: 'Leden - P.E.N.T.A.G.O.N.',
      members_description: 'De leden van A.H.D. P.E.N.T.A.G.O.N. per lichting: de actieve leden en de reünisten.',
      board_title: 'Bestuur - P.E.N.T.A.G.O.N.',
      board_description: 'Het huidige bestuur (H.T.) en alle voorgaande besturen (E.T.) van A.H.D. P.E.N.T.A.G.O.N.',
      gallery_title: "Foto's - P.E.N.T.A.G.O.N.",
      gallery_description: 'Fotoalbums van de activiteiten van A.H.D. P.E.N.T.A.G.O.N.',
      album_title: 'Fotoalbum - P.E.N.T.A.G.O.N.',
      album_page_title: "{title} - Foto's - P.E.N.T.A.G.O.N.",
      album_description: 'Fotoalbum {title} van A.H.D. P.E.N.T.A.G.O.N.',
      not_found_title: 'Pagina niet gevonden - P.E.N.T.A.G.O.N.',
      not_found_description: 'Deze pagina van P.E.N.T.A.G.O.N. bestaat niet (meer).',
    },
    navigation: {
      home: 'Home',
      members: 'Leden',
      board: 'Bestuur',
      gallery: "Foto's",
      member_platform: 'Ledenplatform',
      brand_alt: 'P.E.N.T.A.G.O.N.-wapen',
    },
    home: {
      title: 'A.H.D. P.E.N.T.A.G.O.N.',
      motto: 'Voor iedereen, behalve echte illuminaten, een ondoorgrondelijk geheim.',
      hero_alt: 'Leden van A.H.D. P.E.N.T.A.G.O.N. in smoking tijdens een feestavond',
      membership_heading: 'Waarom lid worden bij A.H.D. P.E.N.T.A.G.O.N.?',
      introduction_one: 'A.H.D. P.E.N.T.A.G.O.N. is een Amsterdams herendispuut gelieerd aan studentenvereniging NoNoMes. Elke dinsdag hebben we een borrel en elk weekend is er altijd wel iemand die een biertje wil drinken of de hele nacht wil doorfeesten. Verder hebben we typisch studentikoze activiteiten als gala’s, rally’s, de jaarlijkse dies, vakanties en nog veel meer.',
      introduction_two: 'Door ons grote reünistenbestand en gedreven houding zijn er volop mogelijkheden om jezelf verder te ontwikkelen buiten je studie, of juist nog dieper je vakgebied in te duiken. Last but not least vind je ongetwijfeld snel een kamer in een van onze dispuutshuizen en geniet je van al onze prachtige, altijd unieke, activiteiten.',
      introduction_three: 'Stuur ons een DM op Instagram voor meer informatie of om een keer langs te komen op een van onze borrels!',
    },
    site: {
      load_error: 'De nieuwste inhoud kon niet worden geladen.',
      loading: 'Inhoud laden…',
      retry: 'Opnieuw proberen',
    },
    social: {
      instagram: 'Volg P.E.N.T.A.G.O.N. op Instagram',
      facebook: 'Volg P.E.N.T.A.G.O.N. op Facebook',
    },
    members: {
      heading: 'Leden',
      active: 'Actief',
      alumni: 'Reünisten',
      load_error: 'De ledenlijst kon niet worden geladen.',
      empty: 'Er zijn nog geen leden om te tonen.',
    },
    boards: {
      heading: 'Bestuur',
      current_heading: 'H.T.',
      former_heading: 'E.T.',
      member: 'Dhr. {name}',
      load_error: 'De besturen konden niet worden geladen.',
      empty: 'Er zijn nog geen besturen om te tonen.',
    },
    gallery: {
      heading: "Foto's",
      open_album: 'Open album {title}',
      photo_alt: '{album}, foto {number} van {total}',
      open_photo: 'Foto {number} van {total} groter bekijken',
      load_error: 'De albums konden niet worden geladen.',
      empty: 'Er zijn nog geen albums om te tonen.',
      album_load_error: "De foto's konden niet worden geladen.",
      album_empty: "Dit album heeft nog geen foto's.",
      album_not_found: 'Dit album bestaat niet (meer).',
      all_albums: 'Naar alle albums',
      lightbox_label: 'Foto groter bekijken',
      lightbox_close: 'Sluiten',
    },
    not_found: {
      heading: 'Pagina niet gevonden',
      message: 'Deze pagina bestaat niet (meer).',
      home_link: 'Naar de homepage',
    },
  },
};

export default new VueI18n({
  locale: 'nl',
  fallbackLocale: 'nl',
  messages,
});
